import * as React from "react";
import { PublishOrEditRunbookSnapshot } from "./PublishOrEditRunbookSnapshot";
interface EditRunbookSnapshotProps {
    runbookSnapshotId: string;
}
export function EditRunbookSnapshotPage({ runbookSnapshotId }: EditRunbookSnapshotProps) {
    return <PublishOrEditRunbookSnapshot runbookSnapshotId={runbookSnapshotId}/>;
}
